class SectionTabs extends HTMLElement {
  constructor() {
    super();
    this.current = 1;
    this.init();
  }
  init() {
    const _this = this;
    $(this).on('click', 'section-tab-item', function (event) {
      const index = $(this).data('index');
      if (!index || _this.current == index) return;
      _this.current = index;
      $(this).addClass('active').siblings('section-tab-item').removeClass('active');
      $(_this).find(`section-tab-content[data-index!=${index}]`).hide();
      $(_this).find(`section-tab-content[data-index=${index}]`).show();
    });

    var event = new CustomEvent('loaded', {});
    this.dispatchEvent(event);
  }
}
class SectionTabItem extends HTMLElement {
  constructor() {
    super();
  }
}
class sectionTabContent extends HTMLElement {
  constructor() {
    super();
  }
}

$(document).ready(function () {
  customElements.define('section-tabs', SectionTabs);
  customElements.define('section-tab-item', SectionTabItem);
  customElements.define('section-tab-content', sectionTabContent);
});
